import React, { useMemo } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { makeStyles } from '@material-ui/core';
import { yupResolver } from '@hookform/resolvers/yup';
import { MaterialPicker } from 'components/MaterialPicker';
import { BuyersCreateForm, BuyersCreateStepProps, useBuyerCreateStepsHooks } from './StepsShared';
import { buyersCreateStep3Schema } from './Step3.yup';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  materialPicker: {
    width: 440,
    marginTop: 100,
  },
});

export const Step3: React.FC<BuyersCreateStepProps> = ({ onSubmit, formName, previousStepData }) => {
  const { t } = useBuyerCreateStepsHooks();
  const classes = useStyles();
  const schema = useMemo(() => buyersCreateStep3Schema(t), [t]);
  const { control, handleSubmit } = useForm<BuyersCreateForm>({
    mode: 'onChange',
    defaultValues: previousStepData,
    resolver: yupResolver(schema),
  });

  return (
    <form id={formName} onSubmit={handleSubmit(onSubmit)}>
      <div className={classes.container}>
        <div className={classes.materialPicker}>
          <Controller
            name="acceptedMaterials"
            control={control}
            render={({ field: { onChange, value }, fieldState }) => (
              <MaterialPicker
                value={value ?? []}
                onValueChange={onChange}
                label={t('buyers.create.step3.acceptedMaterials')}
                placeholder={t('buyers.create.step3.materialPlaceholder')}
                errorMessage={fieldState.error?.message}
                error={Boolean(fieldState.error?.message)}
                includeReject
                required
              />
            )}
          />
        </div>
      </div>
    </form>
  );
};
